var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnverified2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4965_158284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5409V12.0009C16.9994 13.0791 16.6503 14.1282 16.0047 14.9918C15.3591 15.8554 14.4516 16.4871 13.4177 16.7929C12.3837 17.0986 11.2786 17.0619 10.2672 16.6882C9.25584 16.3145 8.39233 15.624 7.80548 14.7194C7.21863 13.8149 6.9399 12.7449 7.01084 11.6691C7.08178 10.5932 7.4986 9.56907 8.19914 8.74945C8.89968 7.92982 9.84639 7.3586 10.8981 7.12098C11.9498 6.88336 13.0501 6.99208 14.035 7.43091M17 8.00091L12 13.0059L10.5 11.5059",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4965_158284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverified2);
export default __webpack_public_path__ + "static/media/unverified2.a6ba0bdd0db85493c78f5b83cb831a8a.svg";
export { ForwardRef as ReactComponent };